import globals from './globals';
import helpers from './helpers';

const clienLinks = ['kp.ru'];

function isClientLink(href) {
	let value = false;

	clienLinks.forEach((link) => {
		if (href.indexOf(link) >= 0) {
			value = true;
		}
	});

	return value;
}

function setEvent(selector, name, callback) {
	let $element = globals.$document;

	let delegatedSelector = null;

	if (typeof selector === 'object') {
		if (typeof selector[0] !== 'undefined') {
			$element = $(selector[0]);
		}

		if (typeof selector[1] !== 'undefined') {
			delegatedSelector = selector[1];
		}
	} else if (typeof selector !== 'undefined') {
		$element = $(selector);
	}

	if (typeof selector !== 'object' && typeof selector === 'undefined') {
		name = `analytics-${name}`;
	}

	$element.on(name, delegatedSelector, callback);
}

function spentOnPage15sec() {
	clearTimeout(globals.$window.data('timeout15Sec'));

	globals.$window.data('timeout15Sec', setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

jQuery.scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
	},
});

spentOnPage15sec();

// header

setEvent('.header__logo', 'click', () => {
	ga('send', 'event', 'nav', 'kp logo header');
});

// test

setEvent(undefined, 'test-start', () => {
	ga('send', 'event', 'test', 'start', '', {nonInteraction: true});
});

setEvent(undefined, 'test-finish', () => {
	const $currentResult = $('.test__result.is-active');

	const result = helpers.clearText($currentResult.find('.test__title').eq(0).text());
	const count = helpers.clearText($currentResult.find('.test__count').text().split('/')[0]);

	ga('send', 'event', 'test', 'finish', result, count);
});

setEvent(undefined, 'test-resume', () => {
	ga('send', 'event', 'test', 'resume');
});

setEvent(undefined, 'test-question-show', () => {
	const $currentStep = $('.test__step.is-active');

	const num = helpers.clearText($currentStep.find('.test__folio b').text());
	const name = helpers.clearText($currentStep.find('.test__subtitle').eq(0).text()).substring(0, 100);

	ga('send', 'event', 'test', `question show ${num}`, name, {nonInteraction: true});
});

setEvent(undefined, 'test-question-answer', () => {
	const $currentStep = $('.test__step.is-active');
	const $currentAnswerWrong = $currentStep.find('.is-wrong');

	const num = helpers.clearText($currentStep.find('.test__folio b').text());

	let name = null;

	if ($currentAnswerWrong.length) {
		const text = helpers.clearText($currentAnswerWrong.clone().children().remove().end().text());

		name = `NO - ${text}`;
	} else {
		const text = helpers.clearText(
			$currentStep
				.find('.is-right')
				.clone()
				.children()
				.remove()
				.end()
				.text(),
		);

		name = `YES - ${text}`;
	}

	name = helpers.clearText(name).substring(0, 100);

	ga('send', 'event', 'test', `question answer ${num}`, name);
});

setEvent([undefined, '.test__step a:not([class])'], 'click', (e) => {
	const $link = $(e.currentTarget);
	const $currentStep = $link.closest('.test__step');

	const num = helpers.clearText($currentStep.find('.test__folio b').text());
	const question = helpers.clearText($currentStep.find('.test__subtitle').eq(0).text());
	const link = helpers.clearText($link.text());
	const name = `${num} - ${question} - ${link}`;

	if (isClientLink($link.attr('href'))) {
		ga('send', 'event', 'client link', 'answer text link click', name);
	} else {
		ga('send', 'event', 'test', 'answer text link click', name);
	}
});

setEvent('.test__start .test__social', 'click', (e) => {
	const name = helpers.clearText(e.currentTarget.dataset.social);

	ga('send', 'event', 'share', 'project share', name);
});

setEvent('.test__result .test__social', 'click', (e) => {
	const name = helpers.clearText(e.currentTarget.dataset.social);

	ga('send', 'event', 'share', 'test final share', name);
});

setEvent([undefined, '.test__sound'], 'click', (e) => {
	const $currentSound = $(e.currentTarget);
	const $currentStep = $currentSound.closest('.test__step');

	const type = $currentSound.hasClass('is-muted') ? 'off' : 'on';
	const num = helpers.clearText($currentStep.find('.test__folio b').text());
	const title = helpers.clearText($currentStep.find('.test__subtitle').eq(0).text());
	const name = `${num} - ${title}`;

	ga('send', 'event', 'sound', type, name);
});

// video

setEvent(undefined, 'video-play', (e, $element) => {
	const name = helpers.clearText($element.closest('.test__result').find('.test__title').eq(0).text());

	ga('send', 'event', 'video', 'play', name, {nonInteraction: false});
});

setEvent(undefined, 'video-finish', (e, $element) => {
	const name = helpers.clearText($element.closest('.test__result').find('.test__title').eq(0).text());

	ga('send', 'event', 'video', 'finish', name);
});

setEvent(undefined, 'video-timing', (e, $element) => {
	const name = helpers.clearText($element.closest('.test__result').find('.test__title').eq(0).text());

	ga('send', 'event', 'video', 'timing 10s', name, 10);
});
